module.exports = __webpack_public_path__ + "media/images/OPL EXPRESS 1-0e7bc46479d85a48067d8d27e1f8a6b9.png";